import { injectable } from "inversify";
import {
  HttpCustomCode,
  HttpCustomCodeCollection,
  HttpCustomCodeProps,
  ICustomCodeCollectionParser,
} from "../systemRepository.types";
import { Result, err, ok } from "neverthrow";
import { ParseError } from "@/repositories/shared/errors/parseError";
import {
  ICustomCode,
  ICustomCodeCollection,
  ICustomCodeProps,
} from "@/domain/entities/system/customCode.types";
import {
  CustomCode,
  CustomCodeCollection,
} from "@/domain/entities/system/customCode";

function parseCustomCode(data: HttpCustomCode): ICustomCode {
  const customCode: ICustomCode = {
    uid: data.uid,
    codeGroup: data.codeGroup,
    code: data.code,
    name: data.name,
    displayOrder: data.displayOrder,
    priorityOrder: data.priorityOrder,
    props: data.props ? parseProps(data.props) : undefined,
  };

  return new CustomCode(customCode);
}

function parseProps(props: HttpCustomCodeProps): ICustomCodeProps {
  return {
    type: props.type,
    color: props.color,
    iconUrl: props.iconUrl,
    latitude: props.latitude,
    longitude: props.longitude,
    busLocationSearchRadiusM: props.busLocationSearchRadiusM,
    popupMessage: props.popupMessage,
  };
}

@injectable()
export class CustomCodeCollectionParser implements ICustomCodeCollectionParser {
  constructor() {}

  toDomain(
    data: HttpCustomCodeCollection
  ): Result<ICustomCodeCollection, ParseError> {
    try {
      const customCodeCollectionData: ICustomCodeCollection = {
        codeGroupName: data?.codeGroupName,
        codeGroup: data?.codeGroup,
        customCodes: data?.customCodes.map(parseCustomCode),
      };
      const customCodeCollection = new CustomCodeCollection(
        customCodeCollectionData
      );
      return ok(customCodeCollection);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
